import { Grid, Card, Paper, Typography, Box, Divider, Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { Header, HeaderActionType, LoadingWrapper } from "ui"
import usePersonStore from "../store/personStore"
import { useQuery } from "@apollo/client"
// import { GET_COMPANY_STUDENTS, CommonThemes, AgeMarkerGraph, DispositionTable, CompanyActionHistoryTable, SessionAgeSort, ImportantQuestionTable, TopFlagTable } from "ft-shared-graphql"
import { useEffect, useState } from "react"
import { CompanyActionHistory, CompanySessionStats, CompanyStudentAgeFlags, CompanyTopFlag, RankingItemDto } from "../../__generated__/graphql"
import { ToggleOff, ToggleOn } from "@mui/icons-material"
export type basicStudentInfo = { __typename: string | undefined, id: string, dob: string }
function mapDataToState(data: any) {
    if (data) {

        return {
            ...data,
            aceFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "ACE")[0].rankings,
            pceFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "PCE")[0].rankings,
            riskFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "Risk")[0].rankings,
            protectiveFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "Protective")[0].rankings
        }

    }

}
const CompanyStudentInsights = ({ onBack }: { onBack: () => void }) => {
    const companyName = usePersonStore(state => state.company.name)
    const companyId = usePersonStore(state => state.company.id)

    const [languageSet, setLanguageSet] = useState("English")
    const [companyInfo, setCompanyInfo] = useState<{
        companyActionHistory: CompanyActionHistory | null,
        sessionStats: CompanySessionStats | null,
        students: basicStudentInfo[],
        pceFlags: RankingItemDto[],
        aceFlags: RankingItemDto[],
        riskFlags: RankingItemDto[],
        protectiveFlags: RankingItemDto[]
        companyStudentAgeFlags: CompanyStudentAgeFlags[]
    }>({
        companyActionHistory: null, sessionStats: null, students: [],
        aceFlags: [], pceFlags: [], riskFlags: [], protectiveFlags: [], companyStudentAgeFlags: []
    })

    // const { loading, data } = useQuery(GET_COMPANY_STUDENTS, {
    //     variables: { id: companyId }
    // })
    // useEffect(() => {
    //     if (data) {
    //         const companyData = mapDataToState(data?.company);
    //         setCompanyInfo(companyData)
    //     }
    // }, [loading])

    const switchLanguages = () => {
        if (languageSet == "English") {
            setLanguageSet("Spanish")
        } else {
            setLanguageSet("English")
        }
    }

    const headerActions: HeaderActionType[] = [
        {
            name: languageSet == "English" ? "Spanish Question Statistics" : "English Question Statistics",
            icon: languageSet == "English" ? <ToggleOff color="disabled" /> : <ToggleOn />,
            action: switchLanguages,
            // isHidden: !company.subscriptions.some(e => e.name?.includes("_ES")) //hide the toggle if its spanish
        }
    ]
    return (
        <LoadingWrapper loading={false}>
            <Card elevation={4} style={{ width: "100%", display: "flex", padding: "16px", height: "auto" }}>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Header title={`Children Insights`} subtitle={`@${companyName}`} onBack={onBack}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, lg: 4 }}>
                                <Paper component="div" variant="outlined">
                                    {/* <SessionAgeSort students={companyInfo.students} companyId={companyId!} /> */}
                                </Paper>
                            </Grid>

                            <Grid size={{ md: 12, lg: 8 }}>
                                <Grid container spacing={1}>
                                    <Grid size={12}>
                                        <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                            {/* <TopFlagTable flags={companyInfo.protectiveFlags} title={"Protective Factors"} /> */}
                                        </Paper>
                                    </Grid>
                                    <Grid size={12}>
                                        <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                            {/* <TopFlagTable flags={companyInfo.riskFlags} title={"Risk Factors"} /> */}
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Divider />
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    {/* <DispositionTable dispositionCount={companyInfo.sessionStats} /> */}
                                </Paper>
                            </Grid>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    {/* <CompanyActionHistoryTable historyCount={companyInfo.companyActionHistory} /> */}
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Divider />
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    {/* <ImportantQuestionTable questionStats={companyInfo.sessionStats} /> */}
                                </Paper>
                            </Grid>
                            {/*TODO: EVENTUALLY FILL IN WITH OTHER QUESTIONS/DATA TBD ON WHAT  */}
                            {/* <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    <ImportantQuestionTable questionStats={companyInfo.sessionStats} />
                                </Paper>
                            </Grid> */}
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            {/* Coming Soon wrapper */}
                            <Grid size={12}>
                                <Box
                                    sx={{
                                        position: "relative", // for overlay
                                    }}
                                >
                                    {/* Dimmed inner content */}
                                    <Paper
                                        sx={{
                                            width: "100%",
                                            padding: ".5rem",
                                            // opacity: 0.4,          // gray out
                                            // pointerEvents: "none", // disable interaction
                                        }}
                                        component="div"
                                        variant="outlined"
                                    >
                                        {/* <CommonThemes companyId={companyId!} /> */}
                                    </Paper>

                                    {/* Overlay label */}
                                    {/* <Box
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // pointerEvents: "none",
                                        }}
                                    >
                                        <Typography variant="h6" color="text.secondary">
                                            Coming Soon
                                        </Typography>
                                    </Box> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    {/* <AgeMarkerGraph data={companyInfo.companyStudentAgeFlags} maxYValue={16} title="Student Age vs Anxiety Marker Average" filter="anxiety" /> */}
                                </Paper>
                            </Grid>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    {/* <AgeMarkerGraph data={companyInfo.companyStudentAgeFlags} maxYValue={15} title="Student Age vs Depression Marker Average" filter="depression" /> */}
                                    {/* <Typography>Graph x axis age, y axis depression</Typography> */}
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Card>
        </LoadingWrapper >
    )
}

export default CompanyStudentInsights